<template>
  <div class="room-setting-general-component">
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.name.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">
            <button class="room-setting-info-btn"
                    v-click-outside="() => isShowTitleInfo = false"
                    @click="isShowTitleInfo = !isShowTitleInfo">
            <span class="info-tooltip"
                  v-if="isShowTitleInfo">{{ $t("setting.name.valid") }}</span>
            </button>
            {{ $t("setting.name.text") }}
        </p>
      </div>
      <div class="room-setting-input-box">
        <input type="text" name="roomTitle" class="room-setting-input" maxlength="35"
               v-model="roomTitle"
               @input="CHANGE_SETTING_DATA({type: 'roomTitle', value: roomTitle})"
          >
        <span class="room-title-count">{{ roomTitle.length }}/35</span>
      </div>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text sub-text main-color">{{ $t("setting.name.link") }}</p>
      </div>
    </div>
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.disclosure.title") }}</h6>
        <div class="room-setting-content-text-box">
            <p class="room-setting-content-text">{{ $t("setting.disclosure.text") }}</p>
        </div>
        <div class="room-setting-input-box">
            <label class="room-setting-label">
                <input type="radio" v-model="isPublic" class="room-setting-radio" name="setPublicMode"
                       :value="true"
                       @change="CHANGE_SETTING_DATA({type: 'definePasswd', value: !isPublic})">
                <span>{{ $t("setting.disclosure.public") }}</span>
            </label>
            <label class="room-setting-label">
                <input type="radio" v-model="isPublic" class="room-setting-radio" name="setPublicMode"
                       :value="false"
                       @change="CHANGE_SETTING_DATA({type: 'definePasswd', value: !isPublic})">
                <span>{{ $t("setting.disclosure.private") }}</span>
            </label>
            
        </div>
      <div class="room-setting-input-box"
           v-if='!isPublic'>
          <input type="password" name="roomSetPwd" class="room-setting-input" :placeholder="$t('setting.disclosure.password.alert')" autoComplete="off" maxlength="20"
                 ref="passwordInput"
                 v-model="roomPassword"
                 @input="CHANGE_SETTING_DATA({type: 'passwd', value: roomPassword})"
                 @focus="isShowPasswordBtn = false"
                 @blur="isShowPasswordBtn = true"/>
          <div class="room-pwd-show"
               v-if="isShowPasswordBtn && !!roomPassword"
               @mouseover="$refs.passwordInput.type = 'text'"
               @mouseleave="$refs.passwordInput.type = 'password'">{{ $t("setting.disclosure.password.see") }}</div>
          <p class="password-validate-text"
             v-if="validatePasswordText">{{ validatePasswordText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  emits: ['roomTitle'],
  data(){
    return{
      roomTitle: '',
      roomPassword: '',
      isShowPasswordBtn: true,
      isShowTitleInfo: false,
      isPublic: true,
      validatePasswordText: ''
    }
  },
  computed:{
    ...mapGetters('roomSetting', ['params'])
  },
  created(){
    this.setDefault()
  },
  watch:{
    roomPassword(){
      if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(this.roomPassword)){
        this.validatePasswordText = this.$t('setting.disclosure.password.valid');
      } else if(this.roomPassword.length >= 20){
        this.validatePasswordText = this.$t('setting.disclosure.password.maxLength');
      } else {
        this.validatePasswordText = '';
      }
    }
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
    setDefault(){
      // 방 제목 기본값 세팅
      this.roomTitle = this.params.roomTitle;

      // 방 공개 여부 기본 값 세팅
      if(this.params.definePasswd){
        this.isPublic = false
        this.roomPassword = this.params.passwd
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.room-setting-general-component{
  padding: 20px 20px 30px;
  white-space: pre-line;
  z-index: 13;

  .room-pwd-show{
    position: absolute;
    top: 9px;
    right: 10px;
    font-size: 14px;
    color: #aaa;
    cursor: pointer;
  }

  .room-setting-save-btn{
    align-self: flex-end;
    width: 60px;
    height: 30px;
    margin-top: 10px;
    border-radius: 8px;
    background-color: #59f;
    font-size: 14px;
    color: #fff;
    pointer-events: auto;

    &:disabled{
      background-color: #c8c8c8;
      color: #e0e0e0;
      pointer-events: none;
    }
  }

  .password-validate-text{
    position: absolute;
    top: 50px;
    left: 10px;
    font-size: 12px;
    color: #ee0055;
  }

  .room-setting-info-btn{
    display: flex;
    justify-content: center;
    position: relative;
    margin-right: 6px;
    width: 16px;
    height: 16px;
    background: #e5e5e5 url('~@/assets/images/exclaim.svg') no-repeat center / 60% auto;
    border-radius: 50%;

    .info-tooltip{
      display: block;
      position: absolute;
      bottom: -55px;
      left: 10px;
      width: 270px;
      padding: 5px 20px;
      z-index: 12;
      border-radius: 10px;
      background-color: #0f0f0f;
      color: #fff;
      word-break: keep-all;
    }
  }
}

[grm-device-mobile]{
  .room-setting-general-component{
    .info-tooltip{
      width: 210px;
      right: -25px;
    }
  }

}
</style>